/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroupAssignmentUserUserType } from './UserGroupAssignmentUserUserType';
import {
    UserGroupAssignmentUserUserTypeFromJSON,
    UserGroupAssignmentUserUserTypeFromJSONTyped,
    UserGroupAssignmentUserUserTypeToJSON,
} from './UserGroupAssignmentUserUserType';

/**
 * 
 * @export
 * @interface UserGroupAssignmentUser
 */
export interface UserGroupAssignmentUser {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUser
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUser
     */
    title?: string;
    /**
     * 
     * @type {UserGroupAssignmentUserUserType}
     * @memberof UserGroupAssignmentUser
     */
    user_type?: UserGroupAssignmentUserUserType;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUser
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the UserGroupAssignmentUser interface.
 */
export function instanceOfUserGroupAssignmentUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserGroupAssignmentUserFromJSON(json: any): UserGroupAssignmentUser {
    return UserGroupAssignmentUserFromJSONTyped(json, false);
}

export function UserGroupAssignmentUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignmentUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'user_type': !exists(json, 'user_type') ? undefined : UserGroupAssignmentUserUserTypeFromJSON(json['user_type']),
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
    };
}

export function UserGroupAssignmentUserToJSON(value?: UserGroupAssignmentUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'user_type': UserGroupAssignmentUserUserTypeToJSON(value.user_type),
        'photo_url': value.photo_url,
    };
}

